/*
 * @Author: v-fmasoud@tableau.com
 * @Date: 2017-10-10 11:20:43
 * @Last Modified by: v-fmasoud@tableau.com
 * @Last Modified time: 2018-01-25 16:39:53
 */
import { applyMiddleware, compose, createStore } from 'redux';
import { logger } from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { routerMiddleware } from 'react-router-redux';

import History from '../common/History';
import reducer from './reducers';

const middlewares = [promise(), thunk, routerMiddleware(History)];
let store = null;

if (window.REACT_APP_DEBUG === 'true') {
  middlewares.push(logger);
  // Interactive Redux DevTools access is gated on REACT_APP_DEBUG, which the
  // deployed Helm values hardcode to "false" in test/stage/prod (only dev sets
  // "true"). That config gate replaces the NODE_ENV log-only backstop the old
  // redux-devtools-extension/logOnlyInProduction import provided, so removing
  // that dependency does not widen DevTools exposure in any deployed non-dev env.
  // Use the browser extension's composer when present, otherwise redux's compose.
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));
} else {
  store = createStore(reducer, applyMiddleware(...middlewares));
}
const defaultStore = store;
export default defaultStore;
